// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-force/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springForceEN: PageEntry = {
  id: "post.federkraft",
  locale: "en",
  slug: "spring-force",
  seo: {
    title: "Glossary: Spring force explained simply | Dietz GmbH",
    description: "The spring force is the force acting on a spring when it is stretched or compressed. It is directly proportional to the elongation or compression of the spring and depends on the s",
  },
  type: "post",
  h1: "Glossary: Spring force explained simply",
  intro: "The spring force is the force acting on a spring when it is stretched or compressed. It is directly proportional to the elongation or compression of the spring and depends on the spring constant. The spring force can be calculated by multiplying the spring constant by the deformation of the spring. In technical applications, spring force is often used to compensate for movements, transfer forces or fulfil storage functions. A precise understanding of spring force is crucial for the correct application of springs in various engineering disciplines.",
  blocks: [

  ],
};
